import React, { useState, useEffect } from "react";
import MenuHeader from "./menuHeader/MenuHeader";
import "./Menu.css";
import CategoryFilter from "./categoriesMenu/categoryFilter";
import MenuTable from "./menuList/menu";
import api from "../../../services/api";
import { useNavigate } from "react-router-dom";
import OrderModal from "./addMore/orderModal";
import { useDispatch, useSelector } from "react-redux";
import { addMenu, addNewCategory, clearRestaurantData } from "../../../redux/Slice/OrderSlice";
import CategoryActions from "./CategoryActions/CategoryActions";
import { getAccessToken, getRestaurantName } from "../../../auth/AuthHandler";
import { SELECTED_RESTAURANT_ID_KEY, SELECTED_RESTAURANT_NAME_KEY } from "../../../services/constants";
import MenuSkeleton from "./MenuSkeleton";

function Menu({ completedDataLoading = () => {}, lodaingState = false, onBack }) {
  const [activeCategory, setActiveCategory] = useState("All");
  const [itemlist, setItemList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [isAddDishFormOpen, setIsAddDishFormOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [categoriesShow, setCategoriesShow] = useState([]);
  const navigate = useNavigate();
  const [refreshStored, setRefreshStored] = useState(false);
  const menuStored = useSelector((state) => state.order.menu);
  const dispatch = useDispatch();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  // Close sidebar if screen width is less than 1024px
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setIsSidebarOpen(false); // Automatically close the sidebar
      } else {
        setIsSidebarOpen(true); // Keep sidebar open for larger screens
      }
    };

    handleResize(); // Call on initial render
    window.addEventListener("resize", handleResize); // Add resize listener

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup listener
    };
  }, []);
  const handleCategorySelect = (category) => {
    setActiveCategory(category);
  };
  const categoriesAdded = useSelector((state) => state.order.newCategories);
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  // let categoriesShow;
  useEffect(() => {
    if (categoriesAdded === null) {
      setCategoriesShow([]);
      return;
    }
    setCategoriesShow([...categoriesAdded]);
  }, [categoriesAdded]);

  async function fetchItem() {
    const token = getAccessToken();
    const restaurantName = getRestaurantName(); // Fetch restaurant name from storage
  
    if (!token || !restaurantName) {
      navigate("/", { replace: true });
      return; // Prevent further execution if no token or restaurant name
    }
  
    try {
      const response = await api.get(`/restaurant-management/menu/restaurants?restaurantName=${restaurantName}`);
      setItemList(response.data.menu);
      dispatch(addMenu(response.data.menu));
  
      if (response.data.categories !== null) {
        dispatch(addNewCategory(response.data.categories));
      }
  
      setRefresh(false);
      setIsLoading(false);
      completedDataLoading();
    } catch (error) {
      console.error("Error fetching menu items:", error);
      setIsLoading(false);
    }
  }
  
  

  const handleRefresh = () => {
    setRefresh(true);
  };
  const handleReferesStored = () => {
    setRefreshStored(!refreshStored);
  };

  const filterdDishList = itemlist.filter((item) => {
    if (activeCategory === "All") return true;
    return item.dishId.dishCatagory === activeCategory;
  });

  const reorderDishlist = () => {
    if (!searchQuery) return filterdDishList;
    const search = searchQuery.toLowerCase();
    const matchinDish = filterdDishList.filter((item) => {
      return item.dishId.dishName.toLowerCase().includes(search);
    });

    return [...matchinDish];
  };
  useEffect(() => {
    if (menuStored.length === 0) {
      fetchItem();
    } else {
      setIsLoading(false);
      if (lodaingState) {
        completedDataLoading();
      }
    }
    if (refresh) {
      fetchItem();
    }
  }, [refresh, lodaingState]);

  useEffect(() => {
    setItemList(menuStored);
  }, [menuStored]);

  const handleAddDishForm = () => {
    setIsAddDishFormOpen(true);
  };

  const handleCloseAddDishForm = () => {
    setIsAddDishFormOpen(false);
  };

  const handleBack = () => {
    dispatch(clearRestaurantData());
    localStorage.removeItem(SELECTED_RESTAURANT_ID_KEY);
    localStorage.removeItem(SELECTED_RESTAURANT_NAME_KEY);
    if (onBack) onBack();
    else navigate("/BOD/restaurant-management");
  };

  if (isLoading) {
    return <MenuSkeleton />;
  }

  return (
    <div className="MenuContent">
      <MenuHeader
        searchQuery={searchQuery}
        handleSearchChange={handleSearchChange}
        onBack={handleBack}
      />
      <h3
        style={{
          textAlign: "left",
          paddingLeft: "20px",
          marginTop: "30px",
          marginBottom: "30px",
        }}>
        Category
      </h3>
      <div className="category">
        <CategoryFilter
          categories={categoriesShow}
          activeCategory={activeCategory}
          onSelectCategory={handleCategorySelect}
        />

        <div className="addDish" onClick={handleAddDishForm}>
          <button>+Add More</button>
        </div>
      </div>
      <div>
        <CategoryActions
          activeCategory={activeCategory}
          items={filterdDishList}
          onSelectCategory={handleCategorySelect}
        />
      </div>
      <div className="menulist-table">
        <MenuTable
          items={reorderDishlist()}
          refresh={handleReferesStored}
          category={activeCategory}
          categoryList={categoriesShow}
        />
      </div>
      <OrderModal
        isOpen={isAddDishFormOpen}
        onClose={handleCloseAddDishForm}
        refresh={handleRefresh}
        categoryList={categoriesShow}
        menuStored={menuStored}
      />
    </div>
  );
}

export default Menu;
